import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { hideModal, setModal } from "../../store/slice/modalSlice";
import { useEffect } from "react";
import {
  Box,
  Button,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTextfield from "../../components/formInputs/TextField";
import { useForm } from "react-hook-form";
import { validatePassword } from "../../utils/validatePassword";
import { userLogin } from "../../api/userApi";
import { loginSuccess } from "../../store/slice/loginSlice";
import { notify } from "../../utils/Notify";
import { clearDataTypeFilters, reset } from "../../store/slice/searchSlice";
import { useState } from "react";
import { clearCustomerDetails } from "../../store/slice/customerDetails";
import { RememberMe } from "@mui/icons-material";
import api from "../../api/endpoints";
import { usagelogApi } from "../../api/usageReportApi";
import http from "../../api/httpService";

interface PropType {
  open: boolean;
  isProfileUser: string;
  shouldNavigate?: boolean;
}

const LoginModal = (props: PropType) => {
  const { open, isProfileUser, shouldNavigate } = props;
  const { control, setError, handleSubmit, setValue } = useForm();
  const [showPassword, setShowPassword] = useState(false);

  const [email, setEmail] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [password, setPassword] = useState<any>("");
  const [checked, setChecked] = useState<any>(false);
  const [ipAddress, setIpAddress] = useState<string>("");
  const dispatch = useAppDispatch();

  const customerDetails = useAppSelector(
    (state) => state.customer.customerDetails
  );
  const allowProfileSignup = customerDetails?.allow_profile;

  function handlePassword() {
    setShowPassword((prev) => !prev);
  }

  const getStoredData = () => {
    let emailVal: any = localStorage.getItem("email");
    let passVal: any = localStorage.getItem("password");
    let rememberVal: any = localStorage.getItem("rememberMe");

    if (emailVal != "" && passVal != "" && rememberVal === "true") {
      setValue("userName", emailVal);
      setValue("password", passVal);
    }
  };
  useEffect(() => {
    getStoredData();
  }, [open]);

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        // const response = await fetch("https://api.ipify.org?format=json");
        const response = await fetch(
          "https://diskoverapi.jgatenext.com/api/get_client_ip/"
        );
        const data = await response.json();
        setIpAddress(data?.client_ip);
        sessionStorage.setItem("user_ipv4_address", data?.client_ip);
      } catch (error) {
        setIpAddress("0");
        console.log("Error fetching IP address:", error);
      }
    };

    fetchIpAddress();
  }, []);

  const fetchAIToken = async () => {
    try {
      const userId = sessionStorage.getItem("user_id");
      let response: any;
      if (api.baseApi === "https://betaapi.jgatenext.com") {
        response = await fetch(
          // `${api.baseApi}/api/generate_ai_userlogin/generate_ai_userlogin?user_id=${userId}`
          `https://diskoverapi.jgatenext.com/api/generate_ai_userlogin/generate_ai_userlogin?user_id=${userId}`
        );
      } else {
        response = await fetch(
          `${api.baseApi}/api/generate_ai_userlogin/generate_ai_userlogin?user_id=${userId}`
        );
      }

      const data = await response.json();
      const aiToken = data?.data?.[0][0]?.user_token;

      if (api.baseApi === "https://betaapi.jgatenext.com") {
        window.open(
          // `https://ai.jgatenext.com/?token=${aiToken}`,
          //   `http://20.204.168.47:8000/?token=${aiToken}`,
          `https://jgate.ai/?token=${aiToken}`,
          "_blank",
          "noopener,noreferrer"
        ); // Open in new tab with token
      } else {
        window.open(
          // `https://ai.jgatenext.com/?token=${aiToken}`,
          // `http://20.204.168.47:8000/?token=${aiToken}`,
          `https://jgate.ai/?token=${aiToken}`,
          "_blank",
          "noopener,noreferrer"
        ); // Open in new tab with token
      }
    } catch (error) {
      console.log("Error fetching AI token:", error);
    }
  };

  const logProfileUserUsageData = (usageActionID: any, profileData: any) => {
    const userMasterId = profileData.user_id ? profileData.user_id : null;
    const informaticscustomerId = profileData.informaticscustomer_id
      ? profileData.informaticscustomer_id
      : null;
    const user_ipv4_address = ipAddress ? ipAddress : null;
    const sessionKey = profileData.session_key ? profileData.session_key : null;
    usagelogApi(
      userMasterId,
      informaticscustomerId,
      null,
      usageActionID,
      null,
      null,
      null,
      null,
      null,
      null,
      // profileData.ip_v4,
      user_ipv4_address,
      null,
      sessionKey,
      1,
      null
    );
  };

  async function onSubmit(data: any, shouldNavigate?: boolean) {
    try {
      const { userName, password } = data;

      const response: any = await userLogin({
        email: userName.trim(),
        password: password.trim(),
        ipAddress: 0,
      });

      const userId = response?.user_id;
      const UserData: any = await http.get(
        `/User/get_usermaster_details_by_id/get_usermaster_details_by_id?&profileuserid=${userId}`
      );

      // localStorage.setItem("rememberMe", rememberMe.toString());

      // clearing user data
      dispatch(reset());
      dispatch(clearCustomerDetails());
      dispatch(clearDataTypeFilters());
      sessionStorage.clear();

      // updating user data
      sessionStorage.setItem("session_key", response?.session_key);

      //Save the user sessio in local storage
      sessionStorage.setItem("csrf_token", response?.csrf_token);
      sessionStorage.setItem("user_id", response?.user_id);
      sessionStorage.setItem("can_access_ai", response?.can_access_ai);
      sessionStorage.setItem("preference", "false");

      sessionStorage.setItem(
        "informaticscustomer_id",
        response?.informaticscustomer_id
      );

      sessionStorage.setItem("isIPLogin", "false");
      dispatch(loginSuccess(response));

      if (response?.data === "Success") {
        if (UserData?.data?.data[0][0]?.user_type === 2) {
          logProfileUserUsageData(2, response);
        } else {
          logProfileUserUsageData(3, response);
        }
        sessionStorage.setItem("fromLoginModel", "true");
        if (shouldNavigate) {
          fetchAIToken();
          setTimeout(() => {
            window.location.reload();
          }, 500); // give browser 0.5s to open the new tab
        } else {
          window.location.reload();
        }
        // sessionStorage.setItem("fromLoginModel", "true");
        // sessionStorage.setItem("isGuestUserLogin", "true");
      } else {
        sessionStorage.setItem("fromLoginModel", "false");
      }
    } catch (err: any) {
      if (err?.response?.data?.data) {
        notify("error", err?.response?.data?.data);
      } else {
        notify("error", "Something went wrong! Please try again");
      }
    }
  }

  useEffect(() => {
    const rememberMeValue = localStorage.getItem("rememberMe");
    if (rememberMeValue === "true") {
      setRememberMe(true);
    }
  }, []);

  function handleKeyPress(e: any) {
    if (e.key === "Enter") {
      //handleSubmit(onSubmit)();
      handleSubmit((data) => onSubmit(data, shouldNavigate))();
    }
  }

  const handleCloseIcon = () => {
    dispatch(hideModal());
    notify(
      "error",
      "Login to your profile with valid credentials using Signin"
    );
  };

  function openLoginInfoModal() {
    dispatch(
      setModal({
        modalType: "HAVING_TROUBLE_LOGGING_IN",
        modalProps: {
          isOpen: true,
        },
      })
    );
  }
  return (
    <Dialog open={open} onClose={() => dispatch(hideModal())} maxWidth={false}>
      {/* ------------------------Title --------------------------------------- */}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6" fontWeight={"600"} fontFamily="Lora">
          Login as Profile User
        </Typography>
        <IconButton onClick={handleCloseIcon}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/*----------------------------- Content------------------------------------- */}
      <DialogContent
        sx={{ width: { sx: "100%", sm: "100%", md: "400px", lg: "400px" } }}
      >
        <Stack direction={"column"} gap={1}>
          <Typography
            fontFamily={"Lora"}
            fontSize={"34px"}
            fontWeight={"700"}
            sx={{
              fontSize: "1rem",
            }}
          >
            User Name
          </Typography>
          <CustomTextfield
            control={control}
            name="userName"
            fullWidth
            size="medium"
            rules={{ required: "User Name is required!" }}
            placeholder="eg. John"
            onKeyPress={handleKeyPress}
            inputValue={email}
          />
          <Typography
            fontFamily={"Lora"}
            fontSize={"34px"}
            fontWeight={"700"}
            sx={{
              fontSize: "1rem",
            }}
          >
            Password
          </Typography>
          <CustomTextfield
            control={control}
            name="password"
            fullWidth
            size="medium"
            rules={{ required: "Password is required!" }}
            placeholder="********"
            handleIcon={handlePassword}
            showeyeIcon
            type={showPassword ? "text" : "password"}
            eyeIconStatus={showPassword}
            onKeyPress={handleKeyPress}
            inputValue={password}
          />

          <Button
            variant="contained"
            size="large"
            fullWidth
            // onClick={handleSubmit(onSubmit)}
            onClick={handleSubmit((data) => onSubmit(data, shouldNavigate))}
            type="submit"
            sx={{ marginTop: 2 }}
          >
            Submit
          </Button>

          <Divider sx={{ my: 1 }} />
          <Button variant="text" href="/resetpassword">
            Forgot password?
          </Button>

          <Button variant="text" onClick={openLoginInfoModal}>
            Having trouble logging in?
          </Button>

          <Box>
            <Typography
              fontWeight={700}
              textAlign="center"
              fontFamily={"Helvetica Neue"}
              fontSize={"14px"}
            >
              Want to Login with Shibboleth?{" "}
              <a
                className="linktext_redirect"
                href={`${api.baseApi}/api/shibboleth_login/shibboleth_log_in`}
              >
                Login
              </a>
            </Typography>
          </Box>

          {(allowProfileSignup && isProfileUser === "false") ||
          customerDetails?.customer_id === 0 ||
          shouldNavigate ? (
            <Box sx={{ marginTop: "10px" }}>
              <Typography
                fontWeight={500}
                textAlign="center"
                fontFamily={"Helvetica Neue"}
                fontSize={"14px"}
                sx={{ color: "#212121" }}
              >
                Don&apos;t have an account?{" "}
                <Button href="/signup">Register</Button>
              </Typography>
            </Box>
          ) : null}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default LoginModal;
